import { DialogModule } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';

import { ModalsService } from '@ib-core/services/modals.service';
import { AbstractBaseComponent } from '@ib-shared/abstract/abstract-base';
import { UserIdleService } from 'angular-user-idle';
import * as dayjs from 'dayjs';
import { takeUntil } from 'rxjs';

import { TimeDiffModule } from '../time-diff/time-diff.module';

@Component({
  selector: 'ib-user-idle',
  templateUrl: './user-idle.component.html',
})
export class UserIdleComponent
  extends AbstractBaseComponent
  implements OnInit, OnDestroy
{
  @ViewChild('modalTmpl') modalTmpl: TemplateRef<unknown>;
  private modalRef: MatDialogRef<unknown>;
  private idleSec = 600;
  private timeoutSec = 300;
  public finishAt: dayjs.Dayjs;

  @Output() timeIsUp = new EventEmitter<void>();

  constructor(
    private userIdle: UserIdleService,
    private modalsS: ModalsService,
  ) {
    super();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.userIdle.setConfigValues({
        idle: this.idleSec,
        timeout: this.timeoutSec,
        ping: 10000,
      });

      //Start watching for user inactivity.
      this.userIdle.startWatching();
      // Start watching when user idle is starting.
      this.userIdle
        .onTimerStart()
        .pipe(takeUntil(this.destroy$))
        .subscribe(count => {
          if (count === 1) {
            this.finishAt = dayjs(new Date()).add(this.timeoutSec, 'seconds');
            this.openModal();
          }
        });

      // Start watch when time is up.
      this.userIdle
        .onTimeout()
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.resetAll();
          this.modalRef?.close();
          this.timeIsUp.emit();
        });
    }, 100);
  }

  ngOnDestroy(): void {
    this.modalRef?.close();
    super.destroySubscriptions();
  }

  public openModal(): void {
    this.modalRef = this.modalsS.openModal(this.modalTmpl, {
      width: '400px',
      maxWidth: '90vw',
      enterAnimationDuration: 0,
      exitAnimationDuration: 0,
      disableClose: true,
    });
  }

  resetAll(): void {
    this.userIdle.stopTimer();
    this.userIdle.resetTimer();
    this.userIdle.startWatching();
  }

  here(): void {
    this.userIdle.stopTimer();
    this.userIdle.resetTimer();
    this.userIdle.startWatching();
    this.modalRef.close();
  }
}

@NgModule({
  declarations: [UserIdleComponent],
  imports: [CommonModule, MatButtonModule, DialogModule, TimeDiffModule],
  exports: [UserIdleComponent],
})
export class UserIdleModule {}
